import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';

import FeeCategoryList from '../../../../components/SiteAdmin/FeeCategory/FeeCategoryList';
import Loader from '../../../../components/Common/Loader/Loader';
import getAllFeeCategoriesQuery from './getAllFeeCategories.graphql';

import s from './FeeCategory.css';

class FeeCategoryPage extends React.Component {
  static defaultProps = {
    feeCategories: {
      loading: true,
    },
  };

  render() {
    const { feeCategories } = this.props;
    const loading = feeCategories && feeCategories.loading;
    return (
      <Loader type={'page'} show={loading}>
        <div className={s.root}>
          <div className={s.container}>
            <div className={s.heading}>Platform Fees</div>
            <div className={s.paddingRoutesSection}>
              <FeeCategoryList feeCategories={feeCategories} />
            </div>
          </div>
        </div>
      </Loader>
    );
  }
}

export default compose(
  withStyles(s),
  graphql(getAllFeeCategoriesQuery, {
    name: 'feeCategories',
    options: {
      ssr: true,
      fetchPolicy: 'network-only',
    },
  }),
)(FeeCategoryPage);
